import { formatPhoneNumberOnInput } from "../core/utils"
import React, { useEffect, useRef, useState } from "react"
import { FormControl } from "react-bootstrap"
import { useField } from "react-final-form"

/**
 * Input pour numéro de téléphone, utilisé uniquement pour la France
 * @param hidden, disabled, name, label
 * @returns {JSX.Element}
 */
const PhoneField = ({ hidden, disabled, name, label }) => {
  const inputRef = useRef()

  const { input, meta } = useField(name, {
    component: "input",
    ref: inputRef
  })

  const [formattedValue, setFormattedValue] = useState(typeof input.value === "string" ? input.value : "")

  const handleChange = (event) => {
    const rawValue = event.target.value
    const formattedPhoneNumber = formatPhoneNumberOnInput(rawValue)
    setFormattedValue(formattedPhoneNumber)
    input.onChange(formattedPhoneNumber)
  }

  useEffect(() => {
    if (input.value) {
      const formattedPhoneNumber = formatPhoneNumberOnInput(input.value)
      setFormattedValue(formattedPhoneNumber)
    }
  }, [])

  const metaError = meta.error && meta.touched
  const hasError = metaError || meta.submitError

  return (
    <div className="d-flex flex-column gap-1">
      <label>{label}</label>
      <div className="d-flex">
        <div className="react-tel-input flag-box">
          <div className="flag fr" />
        </div>
        <FormControl
          {...input}
          type="tel"
          ref={inputRef}
          className={`${hasError ? "textfield-error" : ""}`}
          name={name}
          value={formattedValue}
          hidden={hidden}
          disabled={disabled}
          onChange={handleChange}
        />
      </div>
      {hasError && <p className="required-message">{meta.error || meta.submitError}</p>}
    </div>
  )
}

export default PhoneField
